module.exports = __webpack_public_path__ + "img/summary.c5b65442.svg";